<form [formGroup]="formGroup">
  @if (usePractices && !(!isMainForm && restIndication.value) && capabilities?.canCreateMedicalOrdersWithPractices) {
    <div [ngClass]="{'practices-container': isMainForm}">
      @if (!id?.value) {
        <app-autocomplete
          [form]="formGroup"
          controlName="practice"
          label="practice_to_prescribe"
          placeholder="prescription_medicine_placeholder"
          [items]="filteredPractices"
          [displayFn]="displayItemName"
          (optionSelectedEvent)="onSelectPractice($event)">
        </app-autocomplete>
      }
      @if (id?.value && selectedPractices?.controls?.length > 0) {
        <mat-label>{{ 'practices' | locale }}</mat-label>
      }
      @for (practiceFormGroup of selectedPractices.controls; track practiceFormGroup; let index = $index) {
        <app-item
          [itemText]="practiceFormGroup?.value?.name"
          iconName="test-tube"
          color="bg-dark"
          class="medium-height-icon"
          [index]="index"
          [suffix]="false"
          [displayTrashButton]="!id?.value"
          (removeEvent)="onRemovePractice($event)">
        </app-item>
      }
    </div>
  }

  @if (capabilities?.canCreateFreeTextMedicalOrders) {
    <div class="indicate-rest" formGroupName="restIndicationFormGroup">
      @if (!isMainForm && restIndication.value) {
        <span class="rest-indication">{{ "rest_indication" | locale }}</span>
      }
      @if (isMainForm) {
        @if (!call.provider?.noRestIndication) {
          <mat-checkbox
            color="primary"
            formControlName="restIndication">
            {{ "indicate_rest" | locale }}
          </mat-checkbox>
        } @else {
          <span class="alert danger">
            {{ "no_rest_indication" | locale }}
          </span>
        }
        @if (restIndication.value) {
          <mat-radio-group
            formControlName="restTime"
            color="primary">
            <mat-radio-button [value]="24">24hs</mat-radio-button>
            <mat-radio-button [value]="48">48hs</mat-radio-button>
          </mat-radio-group>
        }
      }
    </div>
  }

  @if (capabilities?.canCreateFreeTextMedicalOrders) {
    <mat-label>{{ 'medical_order_description_label' | locale }}</mat-label>
    <mat-form-field class="textarea">
      <textarea
        matInput
        rows="5"
        [placeholder]="'medical_order_description_placeholder' | locale"
        [maxlength]="usesOwnPractices && this.selectedPractices.length > 0 ? 300 : null"
        formControlName="description">
      </textarea>
      @if (usesOwnPractices && this.selectedPractices.length > 0) {
        <mat-hint [align]="'end'">
          {{ description?.value?.length || 0 }}/{{ 300 }}
        </mat-hint>
      }
      <mat-error>{{ description | errorMessage }}</mat-error>
    </mat-form-field>
  }

  @if (displayInstructionCheckbox) {
    <mat-checkbox
      #instructionCheckbox
      [checked]="!capabilities?.canCreateFreeTextMedicalOrders"
      color="primary"
      (change)="onChangeCheckbox($event.checked)">
      {{ "medical_order_add_instructions" | locale }}
    </mat-checkbox>
  }

  @if (displayInstructions || !displayInstructionCheckbox) {
    <mat-label>{{ 'medical_order_instructions' | locale }}</mat-label>
    <mat-form-field class="textarea">
      <textarea
        matInput
        rows="5"
        [placeholder]="'medical_order_instructions' | locale"
        formControlName="instructions">
      </textarea>
      <mat-error>{{ instructions | errorMessage }}</mat-error>
    </mat-form-field>
  }

  @if (isMainForm) {
    <button
      mat-button
      color="accent"
      [disabled]="!description.value?.trim() && (!instructions.value?.trim() || !instructionCheckbox?.checked) && selectedPractices?.value.length === 0"
      (click)="submitForm()">
      {{ 'medical_order_add' | locale }}
    </button>
  }
</form>
